module.exports = __webpack_public_path__ + "static/img/10.5a3c87a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/sp/10.png
// module id = GIBH
// module chunks = 0